import { AdConfig } from './types';

// AdSense configuration
const ADSENSE_ID = 'ca-pub-XXXXXXXXXX';

// Central ad configuration
export const AD_CONFIG: Record<string, AdConfig> = {
  'resume_builder_left': {
    adsenseId: ADSENSE_ID,
    adSlot: 'XXXXXXXXXX',
    testColor: '#f0f9ff',
    testText: 'Left Sidebar Ad Space'
  },
  'resume_builder_right': {
    adsenseId: ADSENSE_ID,
    adSlot: 'YYYYYYYYYY',
    testColor: '#f0fdf4',
    testText: 'Right Sidebar Ad Space'
  },
  'resume_builder_top': {
    adsenseId: ADSENSE_ID,
    adSlot: 'TTTTTTTTTT',
    testColor: '#f0f9ff',
    testText: 'Top Ad Space'
  },
  'resume_builder_bottom': {
    adsenseId: ADSENSE_ID,
    adSlot: 'ZZZZZZZZZZ',
    testColor: '#fdf2f8',
    testText: 'Bottom Ad Space'
  },
  'resume_builder_mobile_top': {
    adsenseId: ADSENSE_ID,
    adSlot: 'WWWWWWWWWW',
    testColor: '#f0f9ff',
    testText: 'Mobile Top Ad Space'
  },
  'resume_builder_mobile_bottom': {
    adsenseId: ADSENSE_ID,
    adSlot: 'VVVVVVVVVV',
    testColor: '#f0fdf4',
    testText: 'Mobile Bottom Ad Space'
  }
};

// Environment check for test mode
export const isTestMode = import.meta.env.MODE === 'development';